import { BASE_URL } from "constants/routes";
import Modal from "lib/DocumentViewer/Modal";
import React, { useEffect, useRef, useState} from "react";
import { useSelector,useDispatch } from "react-redux";
import "./index.scss";
import { getAuditDocument } from "api/formDisplay";
import LoadingSpinner from "lib/LoadingSpinner";
import Toast from "components/ToastComponent";
import Image from "lib/Image";
import { fetchWorkflowInfoById } from "api/dashboardDetail";
import { setworkFlowInfoLoading } from "redux/dashBoardDetailReducer";
import { Row, Col } from "react-bootstrap"
import option from "../../assets/images/option.svg";
import { reInitiateEsignProcess, revokeAgreement,regenerateTemplate,recallTemplate} from "api/esign";
import AgreementActionModal from "components/AgreementActionModal";
import { clearSelectedData } from "redux/formDisplay";
import ToolTipV1 from "lib/TooltipV1";
import copyclipboard from "assets/images/copyclipboard.svg";
import {  getConfiguration } from "api/configuration";

const Agreement = (props) => {
  const dispatch = useDispatch();
  const { isMobile, selectedData, setSelectedData, formErr, clearFieldError,item } = props;
  const [showModal, setShowModal] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [loading,setLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState(false)
  const [isClicked, setIsClicked] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [allowedAuditStatus, setAllowedAuditStatus] = useState(['completed']);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentModalAction, setCurrentModalAction] = useState("");
  const [currentClickedItem, setCurrentClickedItem] = useState("");
  const [revokeStatus, setRevokedStatus] = useState("");
  const [reInitiationResponseDetails, setReInitiationResponseDetails] = useState({
    status : "",
    show : false,
    message : ""
  });
  const [regenerateTemplateResponseDetails, setRegenerateTemplateResponseDetails] = useState({
    status : "",
    show : false,
    message : ""
  });
  const [isModalButtonLoading, setIsModalButtonLoading] = useState(false);
  const [signerInfo,setSignerInfo] = useState()
  const currentSubWorkFlowId = useSelector(
    (state) => state?.dashboardDetailReducer?.currentSubWorkFlowId
  );
  const organisation_id = useSelector(
    (state) => state?.loggedInUserInfo?.userAuthInfo
  ).organisationInfo?._id;
  const config = useSelector(( state) => state.configurationReducer?.config);
  const dynamic_wf = config?.dynamic_wf;
  const loggedInUserInfo = useSelector((state) => state.loggedInUserInfo?.userAuthInfo)
  let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  const current_user = loggedInUserInfo?.profileInfo?.role_name;
  const workflowInfo =   useSelector(( state) => state.dashboardDetailReducer?.workFlowInfo)
  const agreement_signers_icon = `
  <svg class="text-theme" fill="currentColor" id="noun-users-943303" xmlns="http://www.w3.org/2000/svg" width="30.598" height="17.143" viewBox="0 0 30.598 17.143">
  <path id="Path_53935" data-name="Path 53935" d="M137.458,205.61a3.808,3.808,0,1,0-3.808-3.808A3.812,3.812,0,0,0,137.458,205.61Zm0-6.014a2.206,2.206,0,1,1-2.206,2.206A2.208,2.208,0,0,1,137.458,199.6Z" transform="translate(-131.486 -194.401)"/>
  <path id="Path_53936" data-name="Path 53936" d="M99.6,345.064a2.97,2.97,0,0,1,2.967-2.967h2.805c.084,0,.167,0,.249.01a.829.829,0,0,0,.631-.213.783.783,0,0,0,.255-.582.8.8,0,0,0-.713-.8c-.139-.013-.281-.02-.423-.02h-2.805A4.574,4.574,0,0,0,98,345.064v.329h1.6Z" transform="translate(-98.001 -328.25)"/>
  <path id="Path_53937" data-name="Path 53937" d="M242.87,313.966h1.6v-1.973a3.358,3.358,0,0,1,3.354-3.354h3.093a3.358,3.358,0,0,1,3.354,3.354v1.973h1.6v-1.973a4.968,4.968,0,0,0-4.957-4.957h-3.093a4.972,4.972,0,0,0-4.957,4.957v1.973Z" transform="translate(-234.075 -296.824)"/>
  <path id="Path_53938" data-name="Path 53938" d="M467.786,340.48h-2.805c-.078,0-.156,0-.234.006a.8.8,0,0,0-.52,1.386.789.789,0,0,0,.59.215c.054,0,.108,0,.163,0h2.805a2.971,2.971,0,0,1,2.967,2.967v.329h1.6v-.329a4.575,4.575,0,0,0-4.57-4.57Z" transform="translate(-441.758 -328.237)"/>
  <path id="Path_53939" data-name="Path 53939" d="M444.695,205.61a3.808,3.808,0,1,0-3.809-3.808A3.813,3.813,0,0,0,444.695,205.61Zm0-6.014a2.206,2.206,0,1,1-2.206,2.206A2.208,2.208,0,0,1,444.695,199.6Z" transform="translate(-420.069 -194.401)"/>
  <path id="Path_53940" data-name="Path 53940" d="M275.881,148.4a4.791,4.791,0,1,0-4.791-4.791A4.8,4.8,0,0,0,275.881,148.4Zm0-7.979a3.188,3.188,0,1,1-3.188,3.188A3.192,3.192,0,0,1,275.881,140.422Z" transform="translate(-260.582 -138.82)"/>
</svg>
  `
  const [copiedToClipBoardSuccessFully, setCopiedToClipBoardSuccessFully] =
  useState(false);
  const primaryworkflowAgreements = useSelector(
    (state) =>
      state?.dashboardDetailReducer?.dashboardDetailData?.primaryworkflow
        ?.workflow_documents
  );
  const primaryWfDocsDetails = useSelector(
    (state) =>
      state?.dashboardDetailReducer?.dashboardDetailData?.primaryworkflow
        ?.wfDocsDetails
  );
  const primarywfdata = useSelector( (state) => state?.dashboardDetailReducer?.dashboardDetailData?.primaryworkflow);
  const subowrkflowdata = useSelector( (state) => state?.dashboardDetailReducer?.userSubworkFlowInfo);

  const document_pushed_to_clm = primarywfdata?.document_pushed_to_clm?primarywfdata?.document_pushed_to_clm:false;
  const is_primary_wf = primarywfdata?.is_primary_workflow;
  const primaryWorkflowId = useSelector(
    (state) => state?.urlEncryption?.urlParams?.primaryWorkflowId
  );
  // * This options is for those for which a modal has to be opened
  const options = (props.input_fields?.find(field=> field?.name === "options"))?.options || null
  const Revokeoptions = (props.input_fields?.find(field=> field?.name === "options")) || null

  // * This is for those for which only a action will be performed instead of opening a modal
  const staticOptions = (props.input_fields?.find(field=> field?.name === "static_options"))?.static_options || null

  const modalFormElements = (props.input_fields?.find(field=> field?.name === "options"))
                              ?.form_elements || null
  const showStampInfo = (props.input_fields?.find(field=> field?.name === 'doc_signed'))?.show_tooltip  

  /**
   ** This function will not only close the modal but also will reset all the modal related
   ** states to its default value  
   */ 
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCurrentClickedItem("");
    setCurrentModalAction("");
    setRevokedStatus("");
  }

  const handleShowDocument = (id, url) => {
    let imgURl = `${BASE_URL}/workflow/getWorkflowDocumentById/${organisation_id}/${id}/${url}`;
    setShowModal(true);
    setImageUrl(imgURl);
  };

  const handleAuditReport = async (id) => {
    setLoading(true)
    let response = `${BASE_URL}/workflow/getAuditDocument/${id}`
    if (response !== null){
      setImageUrl(response)
      setShowModal(true)
      setLoading(false)
    }
    else {
      setLoading(false)
      setShowModal(false)
      setToastMessage(true)
      setTimeout(() => {
        setToastMessage(false)
      }, 3000)
    }
  }
  const handleClickOutside = () => {
    setIsClicked(false);
  };
  const ref = useOutsideClick(handleClickOutside);


  useEffect(() => {
    const fetchData =  async() => {
      try {
        if (workflowInfo?.configuration_id) {
          let wf_info = await dispatch(getConfiguration(workflowInfo?.configuration_id)).unwrap()
          let signerInfo = wf_info?.wf_journey?.find(item =>  item?.module_name == 'esign')
          let defaultSignerInfo = signerInfo?.module_settings?.document_settings
          setSignerInfo(defaultSignerInfo)
        }
      } catch (error) {
        console.error("Error fetching configuration:", error);
      }
    };
    fetchData();  
  }, [workflowInfo?.configuration_id]); 

  
  const generateValidName = (name) => {
    if (name) {
      const splitName = name.split("_");
      const uniqueName = [
        ...new Set(splitName.filter((element) => isNaN(parseInt(element)))),
      ];
      let finalName = "";
      for (const element of uniqueName) {
        finalName += element.charAt(0).toUpperCase() + element.slice(1) + " ";
      }
      return finalName.trim();
    }
  };

  const handleStampRetry = async (workflow_id, document_id,primaryWorkflowId) => {
    const options = {
      method: "GET",
      headers : { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      mode:"cors"
    };
    dispatch(setworkFlowInfoLoading(true))
    await fetch(`${BASE_URL}/workflow/reInitiateDocumentForStamping/${workflow_id}/${document_id}`,options)
    dispatch(fetchWorkflowInfoById(primaryWorkflowId ? primaryWorkflowId :  workflow_id))
  }

  const getClassFromStatus = (status) => {
    let dynamicClassName = ""
    switch (status) {
      case 'stamping initiated': dynamicClassName = "stamping_initiated"
        break;
      case 'awaiting stamping': dynamicClassName = "awaiting_stamping"
        break;
      case 'stamping failed': dynamicClassName = "stamping_failed"
        break;
      case 'stamp paper attached': dynamicClassName = "stamp_paper_attached"
        break;
      case 'draft' : dynamicClassName = "draft"
        break;
      case 'completed' : dynamicClassName = "draft"
        break;
      default: dynamicClassName = "draft"
        break;
    }
    return "agreement_status " + dynamicClassName
  }

  const handleCopyLink = (doc) => {
    let wfDoc = selectedData.wfDocsDetails.find(document => document.document_id === doc.document_id)
    if(!wfDoc) wfDoc = primaryWfDocsDetails.find(document => document.document_id === doc.document_id)
    if (wfDoc.document_users?.length === 1)
      navigator.clipboard.writeText(wfDoc.document_users[0].invitation_link);
    else if (wfDoc?.document_users?.length > 1){
      let textToCopy = ""
      for (const user of wfDoc?.document_users) {
        textToCopy += user?.user_name + " : " +  user?.invitation_link + "\n"
      }
      navigator.clipboard.writeText(textToCopy);
    }
  }

  const handleCopyToClipboard = async (transaction_id) => {
    setCopiedToClipBoardSuccessFully(false);
    // e.stopPropagation();
    try {
      await navigator.clipboard.writeText(transaction_id);
      setCopiedToClipBoardSuccessFully(true);
    } catch (err) {
      console.error("Failed to copy text: ", err);
      setCopiedToClipBoardSuccessFully(false);
    }
  };


  const getInvitationLink =  (doc) => {
    let wfDoc = selectedData?.wfDocsDetails?.find(document => document?.document_id === doc?.document_id)
    if(!wfDoc) wfDoc = primaryWfDocsDetails?.find(document => document?.document_id === doc?.document_id)
    let defaultSignerInfo = wfDoc?.document_users?.find(doc => doc?.email_id === loggedInUserInfo?.profileInfo?.emailId)
  if(defaultSignerInfo?.invitation_link){
    return defaultSignerInfo?.invitation_link
  }else{
    return '';
  }
  };
  const handleRedirect = (link) => {
  if(link){
    window.open(link)
  }
  }

  const handleOptionChange = (e,index) => {
    setSelectedId(index);
    setIsClicked(!isClicked);
  };

  const handleOptionButtonClick = (item, action, status_to_update, isPrimaryDoc = false) => {
    //* Opening the Modal if any of the button is clicked 
    setIsModalOpen(true);
    setCurrentClickedItem({...item, isPrimaryDoc});
    setCurrentModalAction(action);
    setRevokedStatus(status_to_update)
  }

  const modalButtonActions = {
    handleRevokeAgreement: async (item, comment, status_to_update ) => { 
      setIsModalButtonLoading(true);
      let revoke_params = {
        primaryWorkflowId: primaryWorkflowId,
        subworkflow_id: currentSubWorkFlowId,
        organisation_id: organisation_id,
        document_id: item?.document_id,
        comments : comment,
        loggedUserId : loggedUserId,
        current_role : current_user,
        status : status_to_update,
        restart_from : 'template',
        configuration_id : config?._id
        
      };
  
     let res =  await revokeAgreement(revoke_params);
     if(res?.status == "success"){
      setIsModalOpen(false);
      window.location.reload();
     }
      
    },
    
    handleRecallTemplate: async (item, comment, status_to_update ) => { 
      setIsModalButtonLoading(true);
      let revoke_params = {
        workflow_id: primaryWorkflowId,
        document_id: item?.document_id,
        status : status_to_update,
        comment : comment,
        subworkflowId : currentSubWorkFlowId,


      };
  
     let res =  await recallTemplate(revoke_params);
     if(res?.status == "Success"){
      setIsModalOpen(false);
      window.location.reload();
     } else{
     setRegenerateTemplateResponseDetails({
      status : "failure",
      show : true,
      message : "Something went wrong!!!"
    })
    setIsModalOpen(false);
    setIsModalButtonLoading(false);
    setTimeout(() => {
      dispatch(clearSelectedData());
      window.location.reload(); 
    }, 2000);
  }
    },
    
    handleRegenerateTemplate: async (item, comment, status_to_update ) => { 
      setIsModalButtonLoading(true);
      let revoke_params = {
        workflow_id: primaryWorkflowId,
        document_id: item?.document_id,
        status : status_to_update,
        comment : comment,
        template_id:item?.template_id,
        subworkflowId : currentSubWorkFlowId,
        organisationId : organisation_id,
        userId : loggedUserId,
        module_name : 'template',
        configuration_id : config?._id

      };
  
     let res =  await regenerateTemplate(revoke_params);
     if(res?.status == "Success"){
      setIsModalOpen(false);
      window.location.reload();
     }else {
      setRegenerateTemplateResponseDetails({
        status : "failure",
        show : true,
        message : "Something went wrong!!!"
      })
      setIsModalOpen(false);
      setIsModalButtonLoading(false);
      setTimeout(() => {
        dispatch(clearSelectedData());
        window.location.reload(); 
      }, 2000);
    }
      
    },
    
    handleReInitiateEsign : async (item, modalFormData) => {
      setIsModalButtonLoading(true);
      const reInitiationParams = {
        primaryWorkflowId : primaryWorkflowId,
        subworkflowId : currentSubWorkFlowId,
        organisationId : organisation_id,
        revokedItemDetails : item,
        restartFrom : item?.restart_from,
        userId : loggedUserId,
        formData : modalFormData
      }

      const reInitiationResponse = await reInitiateEsignProcess(reInitiationParams);
      if(reInitiationResponse?.status?.toLowerCase() === "success") {
        setReInitiationResponseDetails({
          status : "success",
          show : true,
          message : "Successfully re-initiated esign"
        })
      } else {
        setReInitiationResponseDetails({
          status : "failure",
          show : true,
          message : "Something went wrong!!!"
        })
      }

      setIsModalOpen(false);
      setIsModalButtonLoading(false);
      setTimeout(() => {
        dispatch(clearSelectedData());
        window.location.reload(); 
      }, 2000);
    }
  }

  return (
    <div className="pb-1">
    {
      reInitiationResponseDetails.show 
        && 
      <Toast 
        message={reInitiationResponseDetails.message} 
        type={reInitiationResponseDetails.status === "success" ? "success" : "error"} 
      />
    }
     {
      regenerateTemplateResponseDetails.show 
        && 
      <Toast 
        message={regenerateTemplateResponseDetails.message} 
        type={regenerateTemplateResponseDetails.status === "success" ? "success" : "error"} 
      />
    }
    {copiedToClipBoardSuccessFully && (
        <Toast
          // onClose = {()=>dispatch(resetAddedNewComment())}
          message="Copied to clipboard successfully!"
          type="success"
          autoClose={3000}
        />
      )}
    {toastMessage && <Toast message="Unable to view the report" type="error" />}
    {loading && <LoadingSpinner className="loaderDimensionAndPosition"/>}
      {selectedData?.workflow_documents &&
        selectedData?.workflow_documents.length > 0 &&
        selectedData?.workflow_documents.map((item, index) => {
          const invitationLink =  getInvitationLink(item)
         let isDefaultSigner = signerInfo?.find(
  info =>
    info?.template_id === item?.template_id &&
    info?.default_signer_info?.some(signer => signer?.signer_email === loggedInUserInfo?.profileInfo?.emailId)
);
          return (
            <Row className="m-0 mt-3 border-theme-grey rounded-3 gy-3 gy-md-0 d-flex">
            <Col xs={12} md={2} lg={2}>
            <p className="fs-12px text-muted m-0">Name</p>
                <p className="fs-14px m-0">
                  {(item?.document_title &&
                    generateValidName(item?.document_title)) ||
                    selectedData?.full_name}
                </p>
            </Col>
            <Col xs={12} md={2} lg={3}>
            <div className="agreement_status_div">
                  <div className="fs-12px text-muted m-0">Status</div>
                  <div className={`${getClassFromStatus(item?.status?.toLowerCase())} d-flex w-100` }>{item?.status}
                  
                    {(showStampInfo == true && selectedData.estamp_response && item?.stamping_required == true) ? (
                      <span>
                        <ToolTipV1
                          type="primary"
                          trigger="!"
                          triggerWhen="click"
                          selectedData={selectedData}
                          tooltipText={
                            <div className="d-flex flex-column">

                              {selectedData?.estamp_response?.filter(stampResponse => item.document_id === stampResponse.reference_id)?.map((item, index) => (
                                <div key={index}>
                                  <p className="fs-14px m-0">Order ID: {item.order_id}
                                    <span onClick={() => handleCopyToClipboard(item.order_id)} id="copy_clipboard">
                                      <Image
                                        imageSrc={copyclipboard}
                                        className="copy_to_clipboard"
                                      />
                                    </span></p>
                                </div>
                              ))}
                              {selectedData?.estamp_requests?.filter(stampResponse => item.document_id === stampResponse.workflow_document_id)?.map((item, index) => (
                                <div key={index}>
                                  <p className="fs-14px m-0">Stamp type: {item.stamp_type}</p>
                                  <p className="fs-14px m-0">Stamp state: {item.stamp_state}</p>
                                </div>
                              ))}
                            </div>
                          }
                        >
                        </ToolTipV1>
                      </span>
                    ) : null
                    }
        </div>
                </div>
                {item?.status?.toLowerCase() === "stamping failed"  ? (
              <button
                style={{
                  cursor: "pointer",
                }}
                onClick={() =>
                  handleStampRetry(currentSubWorkFlowId, item?.document_id,selectedData?.primary_workflow_id)
                }
                className="stamp_retry"
              >
                Re-initiate
              </button>
            ) : null}
            </Col>
            <Col xs={12} md={2} lg={2}>
           <div className="text-md-center">
           <p className="fs-12px text-muted m-0">Signers</p>
                <span dangerouslySetInnerHTML={{__html:agreement_signers_icon}}></span>
           </div>
            </Col>
            {props?.sign_now_required && eval(props?.sign_now_required) ? 

            <Col xs={6} md={2} lg={options  ? 1 :2}>
            
            <div
          className={`d-flex align-items-center h-100 justify-content-center ${
           isDefaultSigner && invitationLink ? 'cursor-pointer' : 'disabled'
          }`}
         onClick={() => handleRedirect(invitationLink)}
       >
         <button className="btn btn-theme fw-bold fs-14px m-0 text-nowrap">Sign now</button>
    </div>
              </Col>   
        :''}              
              {
                item?.signing_required !== false ? (
                  <Col xs={6} md={2} lg={2}>
                    {/* <div className={`d-flex align-items-center justify-content-center h-100 ${allowedAuditStatus.includes(item?.status.toLowerCase())&&!document_pushed_to_clm? 'cursor-pointer' : 'disabled'}`} 
                     onClick={() =>
                      document_pushed_to_clm ? () => {} : handleAuditReport(item?.document_id)
                      }
                    > */}
                    <div>
                      <div className={`d-flex align-items-center h-100 justify-content-center my-1  ${ !document_pushed_to_clm && !(item?.is_revoked) && !(item?.template_recalled)? 'cursor-pointer' : 'disabled'}`}
               onClick={() =>
              document_pushed_to_clm ? () => {} : handleShowDocument(currentSubWorkFlowId, item?.document_id)
               
              }
              >
              <p className="text-theme fw-bold fs-14px m-0">Preview</p>
              </div>
                      
                        <div className={`d-flex align-items-center justify-content-center h-100 ${allowedAuditStatus.includes(item?.status.toLowerCase()) ? 'cursor-pointer' : 'disabled'}`} onClick={() => handleAuditReport(item?.document_id)}>
                      <p className="text-light-theme fs-12px m-0">View audit trail</p>
                    </div>
                    </div>
                  </Col>
                ) : null
              }
              {
                 (Revokeoptions && eval(Revokeoptions?.show) ||  staticOptions) ? 
              <Col xs={6} md={2} lg={1} className="d-flex justify-content-end">
                {
                  // (options || staticOptions) &&
                  <button
              ref={ref}
              className="option_button"
              onClick={(e) => handleOptionChange(e,index)}
            >
              <Image imageSrc={option} className={`modal_trigger`} /> 
              {
                isClicked && selectedId === index && (
                  <div className="option_list1 shadow-sm rounded-0 border-0 px-1 mb-2 mx-0 bg-white " id="option_list_agreement">
                    {
                      staticOptions?.includes("copy_link") 
                        ?
                          <button
                            onClick={() => handleCopyLink(item)}
                            className="option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey text-nowrap"
                          >
                            {selectedData.wfDocsDetails.find(document => document.document_id === item.document_id)?.status?.toLowerCase() === "out for signature" ? "Copy link" : "No Link"}
                          </button> : null
                    }
                    {
                      /**
                       ** First filtering the array based on {show} condition
                       ** then mapping over it to display the buttons
                       */
                      options?.filter((optionItem) => eval(optionItem?.show)).map(optionItem => (
                        <button
                          className="option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey text-nowrap"
                          onClick={() => handleOptionButtonClick(item, optionItem?.action, optionItem?.status_to_update)}
                        >
                          {optionItem?.label}
                        </button>
                      ))
                    }
                  </div>
                )
              }
            </button>}
            </Col> 
            :""
      }
          

            {showModal && (
              <Modal
                show={true}
                imgSrc={imageUrl}
                setShowModal={setShowModal}
                isPdf={true}
              />
            )}
          </Row>
          );
        })}
      { !is_primary_wf && primaryworkflowAgreements?.length > 0 &&
        primaryworkflowAgreements.map((item, index) => {
          const invitationLink =  getInvitationLink(item)
          let isDefaultSigner = signerInfo?.find(
            info =>
              info?.template_id === item?.template_id &&
              info?.default_signer_info?.some(signer => signer?.signer_email === loggedInUserInfo?.profileInfo?.emailId)
          );
          return (
            <Row className="m-0 mt-3 border-theme-grey rounded-3 gy-3 gy-md-0 d-flex">
            <Col xs={12} md={2} lg={2}>
            <p className="fs-12px text-muted m-0">Name</p>
                <p className="fs-14px m-0">
                {(item?.document_title &&
           generateValidName(item?.document_title)) ||
           selectedData?.full_name}
                </p>
            </Col>
            <Col xs={12} md={2} lg={3}>
            <div className="agreement_status_div">
                  <div className="fs-12px text-muted m-0">Status</div>
                  <div className={`${getClassFromStatus(item?.status?.toLowerCase())} d-flex w-100` }>{item?.status}
                    {(showStampInfo == true && selectedData.estamp_response && item?.stamping_required == true) ? (
                      <span>
                        <ToolTipV1
                          type="primary"
                          trigger="!"
                          triggerWhen="click"
                          selectedData={selectedData}
                          tooltipText={
                            <div className="d-flex flex-column">

                              {selectedData?.estamp_response?.filter(stampResponse => item.document_id === stampResponse.reference_id)?.map((item, index) => (
                                <div key={index}>
                                  <p className="fs-14px m-0">Order ID: {item.order_id}
                                    <span onClick={() => handleCopyToClipboard(item.order_id)} id="copy_clipboard">
                                      <Image
                                        imageSrc={copyclipboard}
                                        className="copy_to_clipboard"
                                      />
                                    </span></p>
                                </div>
                              ))}
                              {selectedData?.estamp_requests?.filter(stampResponse => item.document_id === stampResponse.workflow_document_id)?.map((item, index) => (
                                <div key={index}>
                                  <p className="fs-14px m-0">Stamp type: {item.stamp_type}</p>
                                  <p className="fs-14px m-0">Stamp state: {item.stamp_state}</p>
                                </div>
                              ))}
                            </div>
                          }
                        >
                        </ToolTipV1>
                      </span>
                    ) : null
                    }
                  </div>
                </div>
                {item?.status?.toLowerCase() === "stamping failed" ? (
               <button
                 style={{
                   cursor: "pointer",
                 }}
                 onClick={() =>
                   handleStampRetry(primaryWorkflowId, item?.document_id,null)
                 }
                 className="stamp_retry"
               >
                 Re-initiate
               </button>
             ) : null} 
            </Col>
            <Col xs={12} md={2} lg={2}>
           <div className="text-md-center">
           <p className="fs-12px text-muted m-0">Signers</p>
           <span dangerouslySetInnerHTML={{__html:agreement_signers_icon}}></span>
           </div>
            </Col>
            {props?.sign_now_required && eval(props?.sign_now_required) ? 
            <Col xs={6} md={2} lg={options  ? 1 :2}>
            <div
      className={`d-flex align-items-center h-100 justify-content-center ${
        (isDefaultSigner && invitationLink) ? 'cursor-pointer' : 'disabled'
      }`}
      onClick={() => handleRedirect(invitationLink)}
    >
      <button className="btn btn-theme fw-bold fs-14px m-0 text-nowrap">Sign now</button>
    </div>
            </Col>
       :'' }
            <Col xs={6} md={2} lg={2}>
            <div>
            <div className={`d-flex align-items-center h-100 justify-content-center my-1 ${  !(item?.is_revoked) ? 'cursor-pointer' : 'disabled'}`} onClick={() =>
                handleShowDocument(primaryWorkflowId, item?.document_id)
              }>
              <p className="text-theme fw-bold fs-14px m-0">Preview</p>
              </div>
              <div className={`d-flex align-items-center justify-content-center h-100 ${allowedAuditStatus.includes(item?.status.toLowerCase()) ? 'cursor-pointer' : 'disabled'}`} onClick={() => handleAuditReport(item?.document_id)}>
              <p className="text-light-theme fs-12px m-0">View audit trail</p>
              </div>
              </div>
              </Col>
             { (Revokeoptions && eval(Revokeoptions?.show) ||  staticOptions) ? 

              <Col xs={6} md={2} lg={1} className="d-flex justify-content-end">
                {
                  (options || staticOptions) &&
                  <button
              ref={ref}
              className="option_button"
              onClick={(e) => handleOptionChange(e,selectedData?.workflow_documents?.length+index)}
            >
              <Image imageSrc={option} className={`modal_trigger`} />
              {
                isClicked && selectedId === selectedData?.workflow_documents?.length+index && (
                  <div className="option_list1 shadow-sm rounded-0 border-0 px-1 mb-2 mx-0 bg-white " id="option_list_agreement">
                    {
                      staticOptions?.includes("copy_link")
                        ?
                        <button
                          onClick={() => handleCopyLink(item)}
                          className="option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey text-nowrap"
                        >
                        {primaryWfDocsDetails?.find(document => document.document_id === item.document_id)?.status?.toLowerCase() === "out for signature" ? "Copy link" : "No Link"}
                        </button> : null
                    }
                    {
                      /**
                       ** First filtering the array based on {show} condition
                       ** then mapping over it to display the buttons
                       */
                      options?.filter((optionItem) => eval(optionItem?.show)).map(optionItem => (
                        <button
                          className="option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey text-nowrap"
                          onClick={() => handleOptionButtonClick(item, optionItem?.action, optionItem?.status_to_update, true)}
                        >
                          {optionItem?.label}
                        </button>
                      ))
                    }
                  </div>
                )
              }
            </button>}
            </Col>
             :""}
            
            {showModal && (
              <Modal
                show={true}
                imgSrc={imageUrl}
                setShowModal={setShowModal}
                isPdf={true}
              />
            )}
          </Row>
          );
        })}
        {
          isModalOpen &&
          <AgreementActionModal 
            onClose={handleCloseModal}
            modalButtonActions={modalButtonActions}
            currentModalAction={currentModalAction}
            currentClickedItem={currentClickedItem}
            revokeStatus = {revokeStatus}
            isModalButtonLoading = {isModalButtonLoading}
            modalFormElements = {modalFormElements}
            setSelectedData = {setSelectedData}
            selectedData = {selectedData}
            formErr = {formErr}
            clearFieldError = {clearFieldError}
          />
        }
    </div>
  );
};

const useOutsideClick = (callback) => {
  const ref = useRef();
  useEffect(() => {
    const handleClick = (e) => {
      if (e.target.className !== "modal_trigger") {
        callback();
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [ref]);
  return ref;
};


export default Agreement;
